// 方法
import { filterObjEmptyValue } from '../utils/utils';
import { getThumbUrl } from '../utils/dataUtils';
// 常量
import {
  STATUS_CREATED,
  STATUS_CREATED_CODE,
  HISTORY_LIST_DATA,
} from '../constants/constant';
import { EditVirtualTableColumnType } from './interface';
import { NamePath } from '../constants/interface';

export function dataToUploads(initialValue: any, relativePath: any) {
  if (!initialValue) return initialValue;
  const result = [];
  if (typeof initialValue === 'string') {
    result.push({
      uid: '-1',
      status: 'done',
      url: initialValue,
      thumbUrl: getThumbUrl(initialValue),
      relativePath: relativePath,
    });
  }
  if (Array.isArray(initialValue)) {
    initialValue.forEach((v, i) => {
      result.push({
        uid: `-${i + 1}`,
        status: 'done',
        url: v,
        thumbUrl: getThumbUrl(v),
        relativePath: relativePath[i],
      });
    });
  }
  return result;
}

export function dataToUpload(initialValue: any, relativePath: any) {
  if (!initialValue) return initialValue;
  if (typeof initialValue === 'string') {
    return [
      {
        uid: '-1',
        status: 'done',
        url: initialValue,
        thumbUrl: getThumbUrl(initialValue),
        relativePath: relativePath,
      },
    ];
  }
  return initialValue;
}

export function getRecordCode(recordCode: number, formCode: number) {
  if (recordCode === STATUS_CREATED.ADD || recordCode === STATUS_CREATED.DELETE)
    return recordCode;
  return formCode || recordCode;
}

export function getUpdateStatus(status: any) {
  return status === STATUS_CREATED.ADD
    ? STATUS_CREATED.ADD
    : STATUS_CREATED.UPDATE;
}

interface IFormItemName {
  name?: string;
  key?: number;
}

export function formtaFormItemName(formItemName: string): IFormItemName {
  const result: IFormItemName = {};
  const execData = /(.+)-(\d+)$/.exec(formItemName);
  if (Array.isArray(execData) && execData.length === 3) {
    result.name = execData[1];
    result.key = Number(execData[2]);
  }
  return result;
}

export function formatDataSource(
  dataSource?: any[],
  sort?: any,
  sortFieldName?: string,
) {
  const result: any[] = [];
  dataSource?.forEach?.((item, index) => {
    const itemCopy = { ...item };
    delete itemCopy.key;
    delete itemCopy[HISTORY_LIST_DATA];
    if (sort && sortFieldName) itemCopy[sortFieldName] = index;
    result.push(filterObjEmptyValue(itemCopy));
  });
  return result;
}

export function dataSourceToFormData(columns: EditVirtualTableColumnType[], dataSource?: any[],): any {
  const formFieldNames: string[] = getColumnFieldNames(columns);
  const formData: any = {};
  dataSource?.forEach(item => {
    const key = item.key;
    formFieldNames.forEach(v => {
      formData[`${v}-${key}`] = item[v];
    });
  });
  return formData;
}
/**
 * 获取列配置中的表单字段集合
 * @param columns 列配置
 */
export function getColumnFieldNames(columns: EditVirtualTableColumnType[]): string[] {
  const formFieldNames: string[] = [];
  columns.forEach(item => {
    const { editable, dataIndex, children, } = item;
    if (Array.isArray(children) && children.length) {
      formFieldNames.push(...getColumnFieldNames(children));
      return;
    }
    if (editable && dataIndex) {
      if (Array.isArray(dataIndex)) {
        formFieldNames.push(...dataIndex);
      } else {
        formFieldNames.push(dataIndex);
      }
    }
  });
  return formFieldNames;
}
/**
 * 生成当前行数据的表单键值对
 * @param record 当前行数据
 * @param formFieldNames 表单字段集合
 */
export function setRecordFormData(record: any, formFieldNames?: string[]) {
  const formData: any = {};
  if (!record || !formFieldNames) return formData;
  formFieldNames.forEach(item => {
    formData[`${item}-${record.key}`] = record[item];
  });
  return formData;
}

export function getRowformData(formData: any, rowKey: number) {
  const rowFormData: any = {};
  for (let [key, value] of Object.entries(formData)) {
    const execData = /(.+)-(\d+)$/.exec(key);
    if (Array.isArray(execData) && execData.length === 3) {
      const currentName = execData[1];
      const currentKey = Number(execData[2]);
      if (currentKey === rowKey) rowFormData[currentName] = value;
    }
  }
  return rowFormData;
}

export function filterDataSource(
  dataSource?: any[],
  mergeRowKey?: string,
): any[] {
  if (!dataSource) return [];
  const effectiveDataSource = dataSource.filter(
    v => v[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE,
  );
  if (effectiveDataSource.length && mergeRowKey) {
    const sortObj: any = {};
    const sortDataSource: any[] = [];
    effectiveDataSource.forEach(v => {
      const mergeValue: string = v[mergeRowKey];
      if (!sortObj[mergeValue]) {
        sortObj[mergeValue] = [v];
      } else {
        sortObj[mergeValue].push(v);
      }
    });
    for (let [key, value] of Object.entries(sortObj)) {
      sortDataSource.push({
        [mergeRowKey]: key,
        key: key,
        isMainTable: true,
        childrenItem: value,
      });
      if (Array.isArray(value)) {
        sortDataSource.push(...value);
      }
    }
    return sortDataSource;
  }
  return effectiveDataSource;
}
const uploadTypes: string[] = ['Upload', 'UploadImage', 'UploadImages'];
export function formatUploadDataSource(
  dataSource?: any[],
  columns?: EditVirtualTableColumnType[],
): any[] {
  let newDataSource: any[] = dataSource || [];
  const uploadInfo: any = {};
  let flag: boolean = false;
  columns?.forEach(item => {
    const { dataIndex, formItemType, relativePathName } = item;
    if (
      dataIndex &&
      typeof dataIndex === 'string' &&
      formItemType &&
      uploadTypes.includes(formItemType)
    ) {
      flag = true;
      uploadInfo[dataIndex] = {
        url: dataIndex,
        relativePathName: relativePathName || dataIndex,
      };
    }
  });
  if (Array.isArray(dataSource) && flag) {
    const aaa = dataSource.map(item => {
      const copyItem = { ...item };
      for (let [key, value] of Object.entries(copyItem)) {
        const uploadData = uploadInfo[key];
        if (uploadData && value) {
          let valueData: any[] = [];
          if (Array.isArray(value)) {
            valueData = value.map((v, index) => {
              if (typeof v === 'string') {
                return {
                  uid: `-${index + 1}`,
                  status: 'done',
                  url: v,
                  thumbUrl: getThumbUrl(v),
                  relativePath: copyItem[uploadData.relativePathName]?.[index],
                };
              }
              return v;
            });
          }
          if (typeof value === 'string') {
            valueData = [
              {
                uid: '-1',
                status: 'done',
                url: value,
                thumbUrl: getThumbUrl(value),
                relativePath: copyItem[uploadData.relativePathName],
              },
            ];
          }
          copyItem[key] = valueData;
        }
      }
      return copyItem;
    });
    return aaa;
  }
  return newDataSource;
}

/**
 * 获取默认值
 * @param initialValue 默认值
 * @param record 当前行数据
 * @param name 列字段名
 * @returns 
 */
export function getInitialValue(initialValue: any, record: any, name?: NamePath) {
  if (initialValue) return initialValue;
  const labelKey = Array.isArray(name) ? name[0] : name;
  if (typeof labelKey === 'string') {
    const labelName = formtaFormItemName(labelKey).name;
    return labelName ? record[labelName] : undefined;
  }
  return undefined
}
/**
 * 获取格式化之前的列名
 * @param name 列名
 * @returns 
 */
export function getValueName(name: any) {
  if (Array.isArray(name) && name[0]) {
    return formtaFormItemName(name[0]).name;
  }
  if (typeof name === 'string') {
    return formtaFormItemName(name).name;
  }
}
